









































import Vue from 'vue'
import SettingsService from '../../settings.service'
import copy from '../../../components/selectcopy'

const settingsService = new SettingsService()

export default Vue.extend({
    props: ['settings'],
    data() {
        return {
            ipInput: '',
            ipData: []
        }
    },
    created() {
        if (!this.ipData.length) {
            this.getIPdata()
        }
    },
    methods: {
        getIPdata() {
            settingsService.ips().done((res: any) => {
                this.ipData = res.data
            })
        },
        deleteAll() {
            if (!confirm("Вы действительно хотите удалить все заявки?")) {
                return
            }
            settingsService.deleteAll().done((res: any) => {
                console.log('Ok')
            })
        },
        deleteIP(index: number) {
            this.settings.ip_blocked.splice(index, 1)
        },
        addIP() {
            if (!this.ipInput) {
                return
            }
            let pattern = /^(25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[0-9]{2}|[0-9])(\.(25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[0-9]{2}|[0-9])){3}$/
            if (!pattern.test(this.ipInput))
            {
                return
            }
            for (let ip of this.settings.ip_blocked) {
                if (ip == this.ipInput) {
                    return
                }
            }
            this.settings.ip_blocked.unshift(this.ipInput)
        }
    },
    directives: {
        copy
    }
});



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/webpack/vue/settings/components/extra/Extra.vue